import React from "react";
import { Card, CardContent, Grid, Typography, Box } from "@mui/material";

const CardComponent = () => {
  return (
    <Card
      sx={{
        minWidth: 200,
        maxWidth: 200,
        maxHeight: 100,
        borderRadius: "10px",
        background: "linear-gradient(135deg, #e09, #d0e)",
        boxShadow: 3,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          padding: "8px",
          "&:last-child": {
            paddingBottom: "8px",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#1976d2",
              }}
            >
              <Typography variant="h6">A</Typography>
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              Notification
            </Typography>
            <Typography variant="body2">2 notifications</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CardComponent;
